<div class="white_round padding_sides16">
    <ng-container *ngFor="let iPanel of ns.selectedManufacturer?.panels">
        <app-button-single-line-arrow (click)="panelSelected(iPanel)">{{iPanel.name}}</app-button-single-line-arrow>
    </ng-container>
</div>